export default "__VITE_ASSET__DgkmKhf1__"